import random from 'lodash.random';
import { defineStore } from 'pinia';

const defaultDuration = 8000;
const defaultInterval = 1000;
const variation = 0.5;
const startingPoint = 0;
const endingPoint = 90;

export const useProgressBarStore = defineStore('progress-bar', {
    state: () => ({
        isLoading: true,
        isVisible: false,
        progress: startingPoint,
        timeoutId: undefined,
    }),
    actions: {
        start() {
            this.isLoading = true;
            this.isVisible = true;
            this.progress = startingPoint;
            this.loop();
        },

        loop() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }

            if (this.progress >= endingPoint) {
                return;
            }

            const size = (endingPoint - startingPoint) / (defaultDuration / defaultInterval);
            const progress = Math.round(this.progress + random(size * (1 - variation), size * (1 + variation)));

            this.progress = Math.min(progress, endingPoint);
            this.timeoutId = setTimeout(
                () => this.loop(),
                random(defaultInterval * (1 - variation), defaultInterval * (1 + variation))
            );
        },

        stop() {
            this.isLoading = false;
            this.progress = 100;
            clearTimeout(this.timeoutId);

            setTimeout(() => {
                if (!this.isLoading) {
                    this.isVisible = false;
                }
            }, 200);
        },
    },
});
